import React from "react";
import "../../styles/OutcomesSection.css";
import { Plane, BarChart3, ArrowRight  } from "lucide-react";

 import { Link,} from "react-router-dom";
const cases = [
  {
      name: "Deveras Restaurant",
      icon: <Plane size={18} />,
      details: "Fine dining · South Bengaluru · 80 covers · 14-week engagement",
      tag: "Fine Dining",
      metrics: [
        { value: "↓ 6.8%", label: "Food cost reduction" },
        { value: "₹3.1L", label: "Monthly margin recovered" },
        { value: "↑ 71%", label: "Wastage variance" },
        { value: "Week 3", label: "First results visible" },
      ],
      before: [
        "Food cost at 41% — well above benchmark",
        "No daily P&L — month-end surprises every cycle",
        "Kitchen running on head chef's memory alone",
        "4 dishes with negative contribution margin",
      ],
      after: [
        "Food cost stabilised at 34.2% — held 8 consecutive weeks",
        "Daily P&L live by Week 2. Zero end-of-month shock",
        "Full recipe SOP library. Consistent execution every shift",
        "4 dishes repriced, 2 retired from menu",
      ],
      quote:
        "For the first time in three years, I understood exactly what my restaurant was costing me. That clarity changed how I make every decision.",
        author:
        "— Founder, Deveras Restaurant (name withheld on request)",
        
    },
  {
      name: "Daily Sushis",
      icon: <BarChart3 size={18} />,
      details: "Multi-outlet QSR · 4 locations · Bengaluru · 18-week engagement",
      tag: "Multi-Outlet Chain",
      metrics: [
        { value: "↓ 5.1%", label: "Avg food cost (all 4 sites)" },
        { value: "₹2.4L", label: "Monthly recovered / location" },
        { value: "4 → 1", label: "Systems unified" },
        { value: "8 Locs", label: "Expansion confirmed" },
      ],
      before: [
        "All 4 locations on entirely different operating systems",
        "No centralised vendor contracts — each outlet buying independently",
        "Founder visiting all 4 locations daily — 70+ hour weeks",
        "No scalable infrastructure for expansion",
      ],
      after: [
        "Single operating system across all 4 — identical execution",
        "Centralised vendor contracts. 11% procurement cost saving",
        "Founder reduced to 2 visits/week. First real holiday in 3 years",
        "Full playbook ready for locations 5–8. Expansion confirmed",
      ],
      quote:
        "I was running four locations and I was the system. Now each runs identically and I'm opening four more without fear.",
        author:
        "— Founder, Daily Sushis (name withheld on request)",
    },
];

const OutcomesSection = () => {
  return (
    <section className="premium-outcome">
      <div className="containe">
        <span className="eyebro">REAL OUTCOMES</span>
        <h2>What changes when systems are in place</h2>

        <div className="gri">
          {cases.map((item, i) => (
            <div key={i} className="cas-car">
              
              {/* HEADER */}
              <div className="cas-header">
              <div className="title-ro">
                <div className="logo-bo">
                  {item.icon}
                </div>

                <div>
                  <h3>{item.name}</h3>
                  <p>{item.details}</p>
                </div>
              </div>

              <span className="pil">{item.tag}</span>
            </div>

              {/* METRICS */}
              <div className="metrics-ro">
                {item.metrics.map((m, idx) => (
                  <div key={idx} className="metric-bo">
                    <h4>{m.value}</h4>
                    <span>{m.label}</span>
                  </div>
                ))}
              </div>

              {/* BEFORE AFTER */}
              <div className="before-afte">
                <div className="bo">
                  <span className="labe">BEFORE</span>
                  <ul>
                    {item.before.map((b, i) => (
                      <li key={i}>{b}</li>
                    ))}
                  </ul>
                </div>

                <div className="arro">→</div>

                <div className="bo">
                  <span className="labe">AFTER</span>
                  <ul>
                    {item.after.map((a, i) => (
                      <li key={i}>{a}</li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* QUOTE */}
              <div className="quote-bo">
                <p>"{item.quote}"</p>
                <span className="quote-author">{item.author}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="btn-wrapper">

        <a href="/our-work#cases-section" className="btn-primary">
            View all 6 client outcomes →
            <ArrowRight size={20} />
          </a>
      </div>
      </div>
    </section>
  );
};

export default OutcomesSection;